import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-subsys',
  templateUrl: './subsys.page.html',
  styleUrls: ['./subsys.page.scss'],
})
export class SubsysPage implements OnInit {

  data: any;
  private url: string;
  private site: string;
  private port: string;
  private page: string;
  private MainSys: string;
  private systems: any[] = [];

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient, private dataService: DataService) {

  }

  ngOnInit() {
    //alert('ddd');
    this.getsubsys();
  }
  getsubsys(){
    if (this.route.snapshot.data['special']) {
      this.MainSys = this.route.snapshot.data['special'];
      
      localStorage.setItem('MainSys', this.MainSys);

    }else{
      this.MainSys = localStorage.getItem('MainSys');
    }
    {
      this.page = '/query/querySubSys?MainSys=';
      this.site = AppConfig.getProdUrl();
      this.port = AppConfig.getPort();
      //console.log(this.site + this.port + this.page + this.MainSys);
      this.http.get(this.site + this.port + this.page + this.MainSys).subscribe((ParaNames: any[]) => {
        for (let ParaName of ParaNames) 
        if(ParaName.SubSys != 'ADC' && ParaName.SubSys != 'FEC' && ParaName.SubSys != 'Ground')
          this.systems.push(ParaName);
      },
        (error) => {
          console.log('Abnormal Network');
          // this.PresentToast("无法连接到服务器!");
        });
    }
  }
  table(system) {
    const parameters = { MainSys: this.MainSys, SubSys: system.SubSys};
    this.dataService.setData(42, parameters);
    this.router.navigateByUrl('/table/42');
    // this.navCtrl.push(TablePage, { MainSys: this.MainSys, SubSys });
  }
  functionlist(system) {
    // this.navCtrl.push(FunctionlistPage, { system });
  }
  doRefresh(event) {
    //alert('XXXX');
    this.getsubsys();
    setTimeout(() => {
      console.log('Async operation has ended');
      event.detail.complete();
    }, 1000);
  }
}